export const HERO_SLIDES = [
  {
    bg: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1600&q=80",
    tag: "World-Class Facilities",
    heading: "FORGE YOUR",
    accent: "GREATNESS",
    sub: "Elite training, premium equipment, and a community that pushes you beyond what you thought possible.",
  },
  {
    bg: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1600&q=80",
    tag: "Expert Coaching",
    heading: "TRAIN WITH",
    accent: "THE BEST",
    sub: "50+ certified coaches across every discipline. Your personal transformation starts here.",
  },


  
  {
    bg: "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=1600&q=80",
    tag: "Join 10,000+ Members",
    heading: "BECOME",
    accent: "UNSTOPPABLE",
    sub: "A premium fitness experience that redefines what a gym can be.",
  },
];

export const GALLERY_IMAGES = [
  { src: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600&q=80", label: "Weight Floor" },
  { src: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&q=80", label: "weight Lose" },
  { src: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=600&q=80", label: "weightlifting" },
  { src: "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=600&q=80", label: "hit Zone" },
  { src: "https://images.unsplash.com/photo-1576678927484-cc907957088c?w=600&q=80", label: "Training Area" },
];

export const SERVICES_DATA = [
  {
    icon: "🏋️",
    title: "Powerlifting ",
    desc: "State-of-the-art power racks, calibrated plates, and Olympic barbells. Build maximum strength and dominate the platform with raw power.",
    bg: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80",
  },
  {
    icon: "🚴",
    title: "Cardio Zone",
    desc: "State-of-the-art power racks, calibrated plates, and Olympic barbells. Build maximum strength and dominate the platform with raw power..",
    bg: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&q=80",
  },
  {
    icon: "💪",
    title: "Weight Gain",
    desc: "Fully equipped strength zone with heavy weights, resistance machines, and guided training programs. Build solid muscle mass and achieve the powerful physique you’ve always wanted.",
    bg: "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=800&q=80",
  },
  {
    icon: "🏃",
    title: "Weight Loss",
    desc: "Modern cardio zone with treadmills, bikes, and fat-burning workouts. Lose excess weight, boost stamina, and achieve a lean, fit body.",
    bg: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=800&q=80",
  },
  {
    icon: "🔥",
    title: "HIIT Classes",
    desc: "High-intensity interval training that torches fat, builds athleticism, and keeps your body guessing.",
    bg: "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&q=80",
  },
  {
    icon: "👤",
    title: "Personal Training",
    desc: "1-on-1 sessions with elite certified coaches who design programs precisely tailored to your goals and body mechanics.",
    bg: "https://images.unsplash.com/photo-1576678927484-cc907957088c?w=800&q=80",
  },
];

export const TRAINERS_DATA = [
  {
    name: "Marcus Reid",
    spec: "Strength & Conditioning",
    bio: "Former professional powerlifter. 12 years coaching experience. Specialises in progressive overload and body recomposition.",
    certs: ["NSCA-CSCS", "USAW", "FMS"],
    img: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&q=80",
  },
  {
    name: "Sophia Chen",
    spec: "Yoga & Mobility Coach",
    bio: "500hr RYT certified. Featured in Yoga Journal. Blends traditional practice with modern sports science.",
    certs: ["RYT-500", "FRC", "Pilates"],
    img: "https://images.unsplash.com/photo-1594381898411-846e7d193883?w=600&q=80",
  },
  {
    name: "James Okafor",
    spec: "HIIT & Cardio",
    bio: "Ex-collegiate sprinter turned performance coach. Designs metabolic conditioning programs that deliver measurable results.",
    certs: ["ACE-CPT", "NASM", "CrossFit L2"],
    img: "https://images.unsplash.com/photo-1590239926044-4131b5d3a0e4?w=600&q=80",
  },
  {
    name: "Elena Vasquez",
    spec: "Nutrition & Wellness",
    bio: "Board-certified sports dietitian. Works with athletes from amateur to Olympic level on periodisation nutrition.",
    certs: ["RD", "CISSN", "ACSM"],
    img: "https://images.unsplash.com/photo-1517365830460-955ce3be0547?w=600&q=80",
  },
  {
    name: "Devon Park",
    spec: "Boxing & Combat",
    bio: "Golden Gloves champion with 8 professional bouts. Teaches the fundamentals of boxing to all fitness levels.",
    certs: ["USA Boxing", "NASM", "CPR"],
    img: "https://images.unsplash.com/photo-1600881333168-2ef49b341f30?w=600&q=80",
  },
  {
    name: "Amara Nwosu",
    spec: "Functional Movement",
    bio: "Physical therapist turned performance coach. Specialises in injury prevention, mobility, and movement quality.",
    certs: ["DPT", "FMS", "SFMA"],
    img: "https://images.unsplash.com/photo-1518310383802-640c2de311b2?w=600&q=80",
  },
];

export const PLANS_DATA = [
  {
    tier: "Starter",
    name: "Monthly Plan",
    price: 999,
    featured: false,
    features: [
      { label: "One-Time Registration Fee: ₹500", ok: true },
      { label: "Full Gym Access (All Hours)", ok: true },
      { label: "Locker & Shower Access", ok: true },
      { label: "3 Group Classes / Month", ok: true },
      { label: "Mobile App & Workout Tracker", ok: true },
      { label: "Personal Training Sessions", ok: false },
      { label: "Nutrition Coaching", ok: false },
      { label: "Sauna & Recovery Suite", ok: false }
      ,
    ],
  },
  {
    tier: "Most Popular",
    name: "Quarterly Plan",
    price: 2699,
    featured: true,
    features: [
      { label: "Full Gym Access (All Hours)", ok: true },
      { label: "Premium Locker & Shower", ok: true },
      { label: "Unlimited Group Classes", ok: true },
      { label: "Mobile App & Workout Tracker", ok: true },
      { label: "2 PT Sessions / Month", ok: true },
      { label: "Basic Nutrition Coaching", ok: true },
      { label: "Sauna & Recovery Suite", ok: false },
      { label: "Guest Passes (2/mo)", ok: false },
    ],
  },
  {
    tier: "Elite",
    name: "Power Progress Plan",
    price: 3199,
    featured: false,
    features: [
      { label: "Full Gym Access (All Hours)", ok: true },
      { label: "Signature Locker & Shower", ok: true },
      { label: "Unlimited Group Classes", ok: true },
      { label: "Mobile App & Advanced Analytics", ok: true },
      { label: "6 PT Sessions / Month", ok: true },
      { label: "Full Nutrition & Meal Planning", ok: true },
      { label: "Sauna & Recovery Suite", ok: true },
      { label: "Unlimited Guest Passes", ok: true },
    ],
  },
  {
    tier: "Elite",
    name: "Half-Yearly Plan",
    price: 4999,
    featured: false,
    features: [
      { label: "Full Gym Access (All Hours)", ok: true },
      { label: "Signature Locker & Shower", ok: true },
      { label: "Unlimited Group Classes", ok: true },
      { label: "Mobile App & Advanced Analytics", ok: true },
      { label: "6 PT Sessions / Month", ok: true },
      { label: "Full Nutrition & Meal Planning", ok: true },
      { label: "Sauna & Recovery Suite", ok: true },
      { label: "Unlimited Guest Passes", ok: true },
    ],
  },
  {
    tier: "Elite",
    name: "Annual Plan",
    price: 7999,
    featured: false,
    features: [
      { label: "Full Gym Access (All Hours)", ok: true },
      { label: "Signature Locker & Shower", ok: true },
      { label: "Unlimited Group Classes", ok: true },
      { label: "Mobile App & Advanced Analytics", ok: true },
      { label: "6 PT Sessions / Month", ok: true },
      { label: "Full Nutrition & Meal Planning", ok: true },
      { label: "Sauna & Recovery Suite", ok: true },
      { label: "Unlimited Guest Passes", ok: true },
    ],
  },
  {
    tier: "Elite",
    name: "Combo Plan",
    price: 4999,
    featured: false,
    features: [
      { label: "Full Gym Access (All Hours)", ok: true },
      { label: "Signature Locker & Shower", ok: true },
      { label: "Unlimited Group Classes", ok: true },
      { label: "Mobile App & Advanced Analytics", ok: true },
      { label: "6 PT Sessions / Month", ok: true },
      { label: "Full Nutrition & Meal Planning", ok: true },
      { label: "Sauna & Recovery Suite", ok: true },
      { label: "Unlimited Guest Passes", ok: true },
    ],
  },
];

export const FAQ_DATA = [
  { q: "Is there a joining fee?", a: "No joining fee during our current promotion. You only pay the monthly membership rate, and you can cancel any time with 30 days notice." },
  { q: "Can I freeze my membership?", a: "Yes. Members can freeze their membership for up to 3 months per year at no extra charge. Simply contact our front desk or use the app." },
  { q: "Are classes included in all plans?", a: "Group classes are included from the Standard plan upwards. Basic members receive 3 classes per month, while Standard and Premium get unlimited access." },
  { q: "Do you offer student or corporate discounts?", a: "We offer 20% student discount with valid ID and have corporate wellness partnerships. Contact us to find out if your employer is a partner." },
  { q: "What's the minimum contract length?", a: "All our memberships are rolling month-to-month. We believe in our service so much we don't need to lock you in." },
];

export const FACILITY_IMAGES = [
  "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80",
  "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=500&q=80",
  "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=500&q=80",
  "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=500&q=80",
  "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=500&q=80",
  "https://images.unsplash.com/photo-1576678927484-cc907957088c?w=500&q=80",
  "https://images.unsplash.com/photo-1518310383802-640c2de311b2?w=500&q=80",
  "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=500&q=80",
];

export const TIMETABLE = [
  ["06:00", "HIIT Power", "Weight Training", " weightlifting", "Cardio Blast"],
  ["08:00", "Yoga Flow", "HIIT Power", "Cardio Blast", "Strength Class"],
  ["10:00", "Pilates", "weightlifting", "Weight Training", "HIIT Power"],
  ["12:00", "Cardio Blast", "Weight Training", "HIIT Power", "Open Gym"],
  ["17:00", "Weight Training", "Cardio Blast", "Yoga Flow", "weightlifting"],
  ["19:00", "Cardio Blast", "Strength Class", "HIIT Power", "Weight Training"],
];

export const LOCATIONS = [
  {
    name: "Chelsea Flagship",
    addr: "12 Ironclad Avenue, Chelsea, NY 10011",
    hours: "Mon–Fri 5am–11pm • Sat 6am–10pm • Sun 7am–8pm",
    size: "25,000 sq ft • Full Facility",
    img: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600&q=80",
  },
  {
    name: "Brooklyn",
    addr: "8 Powerhouse St, Williamsburg, NY 11211",
    hours: "Mon–Sat 6am–10pm • Sun 7am–7pm",
    size: "12,000 sq ft • Core Facility",
    img: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&q=80",
  },
  {
    name: "Midtown",
    addr: "350 5th Avenue, Midtown, NY 10001",
    hours: "Mon–Fri 5:30am–10pm • Sat–Sun 7am–6pm",
    size: "8,000 sq ft • Express Facility",
    img: "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=600&q=80",
  },
];

export const NAV_PAGES = ["Home", "About", "Services", "Membership", "Trainers", "Contact"];

export const STATS = [
  ["1K+", "Active Members"],
  ["50+", "Expert Trainers"],
  ["15", "Years Established"],
  ["25K", "Sq Ft Facility"],
  ["98%", "Member Satisfaction"],
];
